import type { Category } from '~/types'

export type CategoryRow = Category & { depth: number }

export function sortCategories(a: Category, b: Category) {
  return (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.name.localeCompare(b.name, 'ro')
}

/** Flatten a category tree (API returns roots with nested children) into indented rows. */
export function flattenCategoryTree(items: Category[], depth = 0): CategoryRow[] {
  const rows: CategoryRow[] = []
  for (const item of [...items].sort(sortCategories)) {
    rows.push({ ...item, depth })
    if (item.children?.length) {
      rows.push(...flattenCategoryTree(item.children, depth + 1))
    }
  }
  return rows
}

/** Label with indentation markers for select dropdowns. */
export function categoryOptionLabel(category: CategoryRow) {
  if (!category.depth) return category.name
  return `${'—'.repeat(category.depth)} ${category.name}`
}
